export { default } from './PromoTile';
